import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoDeducoes } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoDeducoesService extends BaseResourceService<FavorecidoDeducoes> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-deducoes`, injector);
  }

}
